import { opaccAjaxPlugin, opaccStorePlugin } from '../opacc.static.js';

/** @module navigation */

/**
 * Anzeige der Navigationsmenüs
 */
export class OpaccNavigation {
    constructor() {
        this.wrapperElement = document.querySelector('.content');
        this.parentElem = '.opc-navigation';
        this.qrySelector = 'data-op-navtype';
        this.SidebarNavDataSetSelector = 'progressive-descloser-sidebar';
        this.navLevelElement ='li';
        this.qrySelectorValue = 'click';
        this.templateName ='opc-navigation-burgerlist';
        this.navSelector = document.querySelectorAll(`${this.parentElem}[${this.qrySelector}]`);
        this.offCanvasWrapper = document.querySelector('.offcanvas-menu-wrapper');
        this.segmentNavigationWrapper = this.wrapperElement.querySelector('.opc-segment-navigation');
        this.offCanvasNaviElement = document.querySelectorAll('.offcanvas-menu-trigger');
        this.showAllCategoriesButtons = this.wrapperElement.querySelectorAll('.opc-category-navigation .show-all-categories');
        this.sideBarNavigation = document.querySelector(`${this.parentElem}[${this.qrySelector}="${this.SidebarNavDataSetSelector}"]`)
        this.buttonElementSelector = '.opc-segment-navigation .opc-button[data-op-href]';
        this.isMobile = document.querySelector('html.is-mobile');
        this.mainWrapper = document.querySelector('.main-wrapper');
        this.asyncRequestIsRunning = false;

        // Sticky header
        this.allStickyElems = document.querySelectorAll('[data-op-sticky="true"]');

        // evaluate current Nav-Id
        this.currentSidebarNavElem = document.querySelector('#is-active-sidebar-nav');

        this.attachEventListener();
    }

    /**
     * Event Registrierungen im DOM
     */
    attachEventListener() {
        if (this.allStickyElems.length > 0) {
            this.stickyElementNavigation();
        }

        if (this.segmentNavigationWrapper) {
                opaccStorePlugin.init('persistentView');

                // check if view must be loaded from SessionStorage
                if (window.location.search.indexOf('take=') > 0 ) {
                    opaccStorePlugin.get('persistentView', opaccStorePlugin.getCurrentURI());
                }

                this.firePseudoChangeEvent();
                this.segmentNavigationLoader();
        }

        if ([...this.offCanvasNaviElement, ...this.showAllCategoriesButtons].length > 0) {
            this.offCanvasNavigationListener();
        }

        if (this.navSelector.length > 0) {
            this.addBinding();
        }
    }

    addBinding() {
        document.addEventListener('click', e => {
            let elem = e.target;
            if (!elem.closest(`${this.parentElem}[${this.qrySelector}]`)) {
                return;
            }

            if (this.offCanvasWrapper && elem.closest(`.${this.offCanvasWrapper.className}`)) {
                if (elem.closest('.navigation-toggler')) {
                    let liNaviElement = elem.closest(this.navLevelElement);
                    if (liNaviElement.classList.contains('is-open')) {
                        this.toggleIsOpenCssClass(liNaviElement);
                    } else {
                        this.closeSubNavigation(liNaviElement.parentElement.children, liNaviElement);
                    }
                }
            } else if (this.sideBarNavigation && this.isMobile) {
                this.getSidebarNavElems(e);
            } else {
                let liNaviElement = elem.closest(this.navLevelElement);

                if (liNaviElement) {
                    if (liNaviElement.classList.contains('is-open')) {
                        this.toggleIsOpenCssClass(liNaviElement);
                    } else {
                        let navLayout = elem.closest('[data-op-layout]');
                        if (navLayout && navLayout.dataset.opLayout === 'arrow') {
                            if (elem.closest('.navigation-toggler')) {
                                this.closeSubNavigation(liNaviElement.parentElement.children, liNaviElement);
                            } else {
                                this.closeSubNavigation(liNaviElement.parentElement.children);
                            }
                        } else {
                            this.closeSubNavigation(liNaviElement.parentElement.children, liNaviElement);
                        }
                    }
                }
            }
        }, false);
    }

    /**
     *
     *
     */
    offCanvasNavigationListener() {
        [...this.offCanvasNaviElement, ...this.showAllCategoriesButtons].forEach(navElem => {
            navElem.addEventListener('click', () => {
                this.toggleOffCanvasNavigation();
            });
        })

        if (this.offCanvasWrapper) {
            this.offCanvasWrapper.addEventListener('click', e => {
                let closeOffCanvasButton = e.target.closest('.offcanvas-menu-close');
                if (closeOffCanvasButton) {
                    this.toggleOffCanvasNavigation();
                }
            });
        }
    }

    /**
     *
     *
     */
    toggleOffCanvasNavigation() {

        let rootElement = document.querySelector('html');
        let setCssClass = 'offcanvas-menu-open';
        if (this.sideBarNavigation && this.isMobile) {
            setCssClass = 'sidebar-menu-open';
        }

        rootElement.classList.toggle(setCssClass);

        // nur ausführen beim öffnen der Navigation
        if (!rootElement.classList.contains(setCssClass) && this.currentSidebarNavElem) {
            let url = opaccAjaxPlugin.setAsyncUrl();
            let data = {
                type: 'navigation',
                navigationid: this.currentSidebarNavElem.dataset.opNavId,
                template: this.templateName
            };
            let currNav = document.querySelector(`${this.parentElem}[${this.qrySelector}="${this.SidebarNavDataSetSelector}"]`);
            if (!this.asyncRequestIsRunning) {
                opaccAjaxPlugin.fetchAsynPostForm(url, data, this.getNextNavLevel.bind(this,document.querySelector('#is-active-sidebar-nav') || currNav), this.getDefaultErrorFnc, true);
                this.asyncRequestIsRunning = true;
            }
        }

        [...this.offCanvasNaviElement].forEach(elem => elem.classList.toggle('is-active'));
    }

    /**
     *
     *
     */
    stickyElementNavigation() {
        [...this.allStickyElems].forEach(item => {
            const optionsobj = {
                lastScrollTop: 0,
                delta: 5,
                height: item.offsetHeight
            };

            if (item.dataset.opStickyDirection) {
                optionsobj.stickyDirection = item.dataset.opStickyDirection || 'all';
            }
            this.stickyElementListener(item, optionsobj);
        });
    }

    /**
     *
     *
     * @param {*} elem
     * @param {*} options
     */
    stickyElementListener(elem, options) {
        let didScroll;
        window.addEventListener('scroll', () => {
            didScroll = true;

            // run hasScrolled() and reset didScroll status
            setInterval(() => {
                if (didScroll) {
                    this.hasScrolled(elem, options);
                    didScroll = false;
                }
            }, 250);
        });
    }

    /**
     *
     *
     * @param {*} elem
     * @param {*} options
     * @returns {boolean}
     */
    hasScrolled(elem, options) {
        let pageOffset = window.pageYOffset;

        // Make sure they scroll more than delta
        if(Math.abs(options.lastScrollTop - pageOffset) <= options.delta) {
            return;
        }

        if (options.stickyDirection === 'all') {
            this.scrollToActiveState(elem);
        } else if (options.stickyDirection === 'down') {
            if(pageOffset + window.innerHeight < document.body.offsetHeight) {
                // Scroll down
                this.scrollToActiveState(elem);
            } else if (pageOffset > options.lastScrollTop && pageOffset > options.height) {
                // Scroll up
                this.scrollToInactiveState(elem);
            }
        } else if (options.stickyDirection === 'up') {
            if (pageOffset > options.lastScrollTop && pageOffset > options.height) {
                // Scroll down
                this.scrollToInactiveState(elem);
            } else if(pageOffset + window.innerHeight < document.body.offsetHeight) {
                this.scrollToActiveState(elem);
            }
        }

        options.lastScrollTop = pageOffset;
    }

    /**
     *
     *
     * @param {*} elem
     */
    scrollToActiveState(elem) {
        elem.classList.remove('sticky-inactive');
        elem.classList.add('sticky-active');
    }

    /**
     *
     *
     * @param {*} elem
     */
    scrollToInactiveState(elem) {
        let isNav = elem.querySelector(this.parentElem);
        if (isNav) {
            this.closeSubNavigation(isNav.querySelector(this.navLevelElement).parentElement.children);
        }
        elem.classList.remove('sticky-active');
        elem.classList.add('sticky-inactive');
    }

    /**
     *
     *
     * @param {*} navList
     * @param {*} [elem=null]
     */
    closeSubNavigation(navList, elem = null) {
        for (let item of [...navList]) {
            item.classList.remove('is-open');
        }
        if (elem) {
            elem.classList.add('is-open');
        }
    }

    /**
     *
     *
     * @param {*} elem
     */
    toggleIsOpenCssClass(elem){
		elem.classList.toggle('is-open');
	}

    /**
     *
     *
     */
    segmentNavigationLoader() {
        this.wrapperElement.addEventListener('click', e => {
            let buttonElement = e.target.closest(this.buttonElementSelector);

            if (!buttonElement) { return; }

            opaccStorePlugin.clear('persistentView');
            buttonElement.classList.add('is-progress');
            opaccAjaxPlugin.fetchAsynGetForm(buttonElement.dataset.opHref, this.appendDataToResultList.bind(this, buttonElement), this.getDefaultErrorFnc, true);
        });
    }

    /**
     *
     *
     * @param {*} e
     */
    getSidebarNavElems(e) {
        let navCrumbs = e.target.closest('.crumbs');
        let navLevelBackBtn = null;
        if (navCrumbs) {
            navLevelBackBtn = navCrumbs.lastElementChild.querySelector('.is-active-crumb');
        }
        if (!e.target.closest('li.has-children') && !navLevelBackBtn) {
            return;
        }

        e.preventDefault();


        let navHref = e.target.href;
        if (!navHref) { return; }

        let url = opaccAjaxPlugin.setAsyncUrl();
        let data = {
            type: 'navigation',
            navigationid: e.target.dataset.opNavId,
            template: this.templateName
        };

        this.mainWrapper.style.pointerEvents = 'none';

        if (!this.asyncRequestIsRunning) {
            opaccAjaxPlugin.fetchAsynPostForm(url, data, this.getNextNavLevel.bind(this,e.target), this.getDefaultErrorFnc, true);
            this.asyncRequestIsRunning = true;
        }
    }

    /**
     *
     *
     * @param {*} response
     */
    async getNextNavLevel(targetElem, response) {
        this.asyncRequestIsRunning = false;
        this.mainWrapper.style.pointerEvents = 'auto';
        let navElem = await targetElem.closest(`${this.parentElem}[data-op-asynctemplate="${this.templateName}"]`);
        if (!navElem) { return; }

        navElem.outerHTML = await response.dataAsJson.showItems;
        navElem.addEventListener('click', e => {this.getSidebarNavElems(e)});
    }

    /**
     *
     *
     * @param {*} buttonElement
     * @param {*} response
     */
    appendDataToResultList(buttonElement, response) {
        let targetSelector = buttonElement.parentElement.dataset.opTarget || '#result-list';
        buttonElement.classList.remove('is-progress');

        let htmlObj = document.createElement('div');
        let listChildren = document.createDocumentFragment();
        htmlObj.innerHTML = response.dataAsHtml;
        Array.from(htmlObj.querySelector(targetSelector).children).forEach( item => {
            listChildren.append(item);
        });

        let buttonElementSelector = `.opc-segment-navigation[data-op-target="${targetSelector}"] .opc-button[data-op-href]`;
        let moreButton = htmlObj.querySelector(buttonElementSelector);
        if (moreButton) {
            buttonElement.dataset.opHref = moreButton.dataset.opHref;
        }

        if (buttonElement.dataset.opHref === 'javascript:void(0);') {
            buttonElement.classList.add('is-hidden');
        }

        document.querySelector(targetSelector).appendChild(listChildren);

        this.firePseudoChangeEvent();

        let resultWrapperSelector = '.result-view-wrapper';
        const resultWrapperElem = this.getParentElement(buttonElement, resultWrapperSelector);
        resultWrapperSelector = resultWrapperElem && resultWrapperElem.hasAttribute('id') ? `#${resultWrapperElem.id}` : resultWrapperSelector;
        if (document.querySelector(resultWrapperSelector)) {
            this.modifyHistory(targetSelector);
            opaccStorePlugin.set('persistentView', opaccStorePlugin.getCurrentURI(), resultWrapperSelector, buttonElementSelector);
        }
    }

    getParentElement(element, targetSelector) {
        if (!element.parentElement) {
            return null;
        }

        const parent = element.parentElement.querySelector(targetSelector);
        if (!parent) {
            return this.getParentElement(element.parentElement, targetSelector);
        }
        return parent;
    }

    /**
     * Change-Event triggern, um asynchrone Change-Operationen auszuführen
     * @private
     * @ignore
     */
    firePseudoChangeEvent() {
        let triggerEvent = new Event('change');
        document.querySelector('.content').dispatchEvent(triggerEvent);
    }

    /**
     *
     *
     * @param {*} selector
     */
    modifyHistory(selector) {
        let stateData = document.querySelector(selector).childElementCount;
        let urlParams = window.location.search.substring(1);
        if (urlParams.length === 0) {
            urlParams = 'take=async';
        } else if (urlParams.indexOf('take=') == -1 ) {
            urlParams += '&take=async';
        }
        history.replaceState({ itemCount: stateData }, 'newResult', `${window.location.pathname}?${urlParams}`);
    }
}